












































import Vue from 'vue';

const ParagraphWrapperProps = Vue.extend({
  props: {
    paragraphVariant: {
      type: String,
      default: 'variant-6-6',
    },
    paragraphSpacing: {
      type: String,
      default: 'spacing-below',
    },
    reorderMobile: {
      type: Boolean,
      default: false,
    },
    paragraphBackground: {
      type: String,
      default: 'white',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
});

export default class ParagraphWrapper extends ParagraphWrapperProps {
  get paragraphClass () {
    // all variants that are searched for includes rather than equality can have variant-no-indent along with the column count.
    // For example: variant-6-6 can either be 'variant-6-6' or 'variant-6-6 variant-no-indent'
    const isOverlappingVariant = ['variant-4-8-overlapping', 'variant-8-4-overlapping'].includes(this.paragraphVariant);
    return {
      'brandhub-paragraph-wrapper--edit-mode': this.editMode,
      'brandhub-paragraph-wrapper--white': this.paragraphBackground === 'white',
      'brandhub-paragraph-wrapper--black': this.paragraphBackground === 'black',
      'brandhub-paragraph-wrapper--theme': this.paragraphBackground === 'theme',
      'brandhub-paragraph-wrapper--variant-no-intend': this.paragraphVariant.includes('variant-no-indent') || isOverlappingVariant,
      'brandhub-paragraph-wrapper--variant-intend': !this.paragraphVariant.includes('variant-no-indent') && !isOverlappingVariant,
      'brandhub-paragraph-wrapper--variant-4-8': this.paragraphVariant === 'variant-4-8',
      'brandhub-paragraph-wrapper--variant-8-4': this.paragraphVariant === 'variant-8-4',
      'brandhub-paragraph-wrapper--variant-6-6': this.paragraphVariant.includes('variant-6-6'),
      'brandhub-paragraph-wrapper--variant-4-4-4': this.paragraphVariant.includes('variant-4-4-4'),
      'brandhub-paragraph-wrapper--variant-3-6-3': this.paragraphVariant === 'variant-3-6-3',
      'brandhub-paragraph-wrapper--variant-2-8-2': this.paragraphVariant === 'variant-2-8-2',
      'brandhub-paragraph-wrapper--variant-2-4-4-2': this.paragraphVariant === 'variant-2-4-4-2',
      'brandhub-paragraph-wrapper--variant-12': this.paragraphVariant === 'variant-12',
      'brandhub-paragraph-wrapper--variant-12-4-8': this.paragraphVariant === 'variant-12-4-8',
      'brandhub-paragraph-wrapper--variant-12-8-4': this.paragraphVariant === 'variant-12-8-4',
      'brandhub-paragraph-wrapper--variant-12-6-6': this.paragraphVariant === 'variant-12-6-6',
      'brandhub-paragraph-wrapper--variant-4-8-overlapping': this.paragraphVariant === 'variant-4-8-overlapping',
      'brandhub-paragraph-wrapper--variant-8-4-overlapping': this.paragraphVariant === 'variant-8-4-overlapping',
      'brandhub-paragraph-wrapper--spacing-above': this.paragraphSpacing.includes('variant-spacing-above') && !isOverlappingVariant,
      'brandhub-paragraph-wrapper--spacing-below': this.paragraphSpacing.includes('variant-spacing-below') && !isOverlappingVariant,
      'brandhub-paragraph-wrapper--no-spacing': this.paragraphSpacing === 'variant-no-spacing',
      'brandhub-paragraph-wrapper--reorder-mobile': this.reorderMobile,
    };
  }

  get wrapperClass () {
    return {
      'brandhub-paragraph-wrapper__row--reorder': this.reorderMobile,
    };
  }

  get showParagraphTop () {
    const doNotShowIn = ['variant-8-4', 'variant-4-8', 'variant-6-6', 'variant-4-8-overlapping', 'variant-8-4-overlapping'];
    return !doNotShowIn.includes(this.paragraphVariant);
  }

  get showParagraphCenter () {
    const doNotShowIn = ['variant-12'];
    return !doNotShowIn.includes(this.paragraphVariant);
  }

  get showParagraphBottom () {
    const showIn = ['variant-2-4-4-2'];
    return showIn.includes(this.paragraphVariant);
  }
}
